import { render, staticRenderFns } from "./RoleListPanel.vue?vue&type=template&id=8561940a&scoped=true&"
import script from "./RoleListPanel.vue?vue&type=script&lang=js&"
export * from "./RoleListPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoleListPanel.vue?vue&type=style&index=0&id=8561940a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8561940a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
